import { setLoading, setUser } from './reducer'
import { AxiosResponse } from 'axios'
import { useMessage } from '@hooks/useMessage'
import { serverPath } from '@constants/api-endpoints'
import { ErrorMessages } from '@constants/errors'
import axiosInstance from '@config/axios'
import { LoginRequestDto, LoginResponseDto } from '@dto/user/user.response.dto'
import { AppDispatch } from '@store/index'
import { appHistory } from '@router/history'
import { getDefaultPathByRole, routersPath } from '@router/routes-path'
import { errorMapper } from '@utils/errorMapper'

export const authLogin =
  ({ login, password }: LoginRequestDto) =>
  async (dispatch: AppDispatch) => {
    const { error } = useMessage()
    try {
      dispatch(setLoading(true))

      const {
        data: { accessToken, refreshToken, isActive, ...user },
      }: AxiosResponse<LoginResponseDto> = await axiosInstance.post(serverPath.LOGIN, {
        login,
        password,
      })

      dispatch(
        setUser({
          isActive,
          isAuth: true,
          accessToken,
          refreshToken,
          user,
        }),
      )

      user?.role && appHistory.push(getDefaultPathByRole(user?.role))
    } catch (e) {
      error(errorMapper(ErrorMessages.AUTH_FAILED, e))
    } finally {
      dispatch(setLoading(false))
    }
  }

export const authLogout = () => (dispatch: AppDispatch) => {
  try {
    appHistory.push(routersPath.LOGIN_PAGE)
    dispatch(
      setUser({
        isAuth: false,
        user: null,
      }),
    )
  } catch (e) {
    throw new Error('Logout failed')
  }
}
